<div [ngClass]="{ 'multi-market-cm': isMultiMarketTemplate === true }">
    <div class="odds-card-header" [hidden]="!isHeaderAlwaysVisible && !showOddsCardHeader" data-crlat="eventOddsHeader">
        <div class="odds-left" *ngIf="dateTitle">
            <span class="odds-header-title" [textContent]="dateTitle" data-crlat="dateTitle"></span>
        </div>
        <div class="odds-right multi-market-tooltip-headers" *ngIf="!hideOddsTitles && !isListTemplate">
            @if (checkStats()) {
                <span
                    class="odds-header-score hasStats"
                    [ngClass]="statsFilter?.statsSorting === 'Competition' ? 'hasCompetition-coral-mobile' : 'other'">
                    <svg [ngClass]="'svg-icon-stats'">
                        <use [attr.xlink:href]="'#stats-' + statsFilter.statsDisplay"></use>
                    </svg>
                </span>
                <span class="odds-header-score"></span>
            }

            <span
                class="odds-header-score"
                [ngClass]="isIP ? 'odds-header-mobile' : isHP ? 'odds-header-home' : ''"
                *ngIf="eventScoreLabel"
                data-crlat="scoreHeader">
                <span
                    *ngFor="let scoreHeader of scoreHeaders"
                    [ngClass]="scoreHeaders.length > 2 ? (isHP ? 'odds-' + scoreHeader : isIP ? 'oddsIP-' + scoreHeader : '') : ''"
                    [textContent]="scoreHeader"
                    data-crlat="scoreHeader.item"></span>
            </span>
            <span class="odds-header-score" [ngClass]="isHP || isIP ? 'odds-header-L' : ''" *ngIf="dartsOnlyLegs">
                <span [textContent]="scoreLabels.DARTLEGLABEL"></span>
            </span>
            <span
                class="odds-header-col"
                *ngFor="let title of headTitles"
                [textContent]="getHeader(title)"
                data-crlat="headTitles"
                [tooltip]="title"
                [enableTooltip]="isMultiMarketTemplate && showTootltip"
                [toolTipArgs]="toolTipArgs"
                [dynamicTooltipTitle]="true"></span>
        </div>
    </div>
</div>
